import React, { lazy, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { loadScript } from "../Helpers/utils/loadScript";
import QuizResultsDetails from "../Pages/GetReady/Components/GetReadyKnowledgeTest/QuizResultsDetails";
import BdeCourseRedirect from "../Pages/BdeCourseRedirect/BdeCourseRedirect";
import RegisterNewCourse from "../Pages/RegisterNewCourse/RegisterNewCourse";
const CreateLearnerNewPasswordPopup = lazy(() => import("../Pages/CreateLearnerNewPassword/CreateLearnerNewPassword"));

// Lazy-loaded pages
const CourseOverview = lazy(() => import("../Pages/CourseOverview/CourseOverview"));
const CourseCategory = lazy(() => import("../Pages/CourseCategory/CourseCategory"));
const Getready = lazy(() => import("../Pages/GetReady/Getready"));
const KnowledgeTest = lazy(() => import("../Pages/GetReady/KnowledgeTest"));
const KnowledgeTestMain = lazy(() => import("../Pages/GetReady/KnowledgeTestMain"));
const LearnerCompareCourses = lazy(() => import("../Pages/LearnerCompareCourses/LearnerCompareCourses"));
const AttemptQuize = lazy(() => import("../Pages/GetReady/Components/GetReadyKnowledgeTest/AttemptQuize"));
const AboutNewSection = lazy(() => import("../Pages/About/AboutNew"));
const SublicenseAllCourses = lazy(() => import("../Pages/CourseCategory/sublicenseAllCourses/SublicenseAllCourses"));
const EBooks = lazy(() => import("../Pages/EBooks/EBooks"));
const ContactUsNew = lazy(() => import("../Pages/eventContact/ContactUsNew"));
const KnowledgeTestSelect = lazy(() => import("../Pages/GetReady/Components/GetReadyKnowledgeTest/KnowledgeTestSelect"));
const QuizLicenseTypePage = lazy(() => import("../Pages/GetReady/Components/GetReadyKnowledgeTest/QuizLicenseTypePage"));
const LearnerSideVliBlogs = lazy(() => import("../Pages/LearnerSideVliBlogs/LearnerSideVliBlogs"));
const ViewLearnerSideVliBlogs = lazy(() => import("../Pages/ViewLearnerSideVliBlogs/ViewLearnerSideVliBlogs"));
const InstitutepasswordAndOtp = lazy(() => import("../Pages/InstituteCreatePassword/InstitutePassword&Otp"));
const PartnerOwnerRegisteration = lazy(() =>import("../Pages/PartnerRegisteration/PartnerRegisteration"));
const MapView = lazy(() =>import("../Pages/UserMapCurrentLocation/UserMapCurrentLocation"));
const TrackStudentLiveLocation = lazy(() =>import("../Pages/TrackStudentLiveLocation/TrackStudentLiveLocation"));
const MobileViewFindCourse = lazy(() =>import("../Pages/MobileViewFindCourse/MobileViewFindCourse"));
const GetReadyWithKnowledgeTest = lazy(() => import("../Pages/GetReadyKnowledgeTest/GetReadyKnowledgeTest"));
const KnowledgeHistory = lazy(() => import("../Pages/GetReady/Components/GetReadyKnowledgeTest/KnowledgeHistory"));

// const PublicRoutes = () => {
//   const location = useLocation();

//   // useEffect(() => {
//   //   const loadAllScripts = async () => {
//   //     try {
//   //       await Promise.all([
//   //         loadScript("https://accounts.google.com/gsi/client"),
//   //         loadScript("https://www.google.com/recaptcha/api.js?render=6LeTY84pAAAAANkmW6S9YmRWPuy3dqHqzCCu9HN9"),
//   //         loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyDxLNDr-m4bm23SdDjvqaSqis5DmjoeG7g&libraries=places"),
//   //         loadScript("https://www.paypal.com/sdk/js?client-id=AclMwCy7mwkHpyjRbes0TiHU0ljo2uuJ44abw7-S7t81m27bfmIwbzknHPac1IOG8H4XqIxA0rLqPzIq")
//   //       ]);

//   //       console.log("All scripts loaded ✅");
//   //     } catch (error) {
//   //       console.error("Error loading scripts ❌", error);
//   //     }
//   //   };

//   //   // OPTIONAL: delay loading (recommended for performance)
//   //   const timer = setTimeout(() => {
//   //     loadAllScripts();
//   //   }, 30000); // delay 30 sec

//   //   return () => clearTimeout(timer);
//   // }, []);

//   return (
//     <Routes key={location.pathname}>
//       <Route path="/contact-us" element={<ContactUsNew />} />
//       <Route path="/about" element={<AboutNewSection />} />
//       <Route path="/course" element={<CourseOverview />} />
//       <Route path="/license-category" element={<CourseCategory />} />
//       <Route path="/vehicle-category" element={<CourseCategory />} />
//       <Route path="/sublicense-allcourses" element={<SublicenseAllCourses />} />
//       <Route path="/get-ready" element={<Getready />} />
//       <Route path="/get-ready/knowledge-test" element={<KnowledgeTestMain />} />
//       <Route path="/get-ready/knowledge-test-quiz" element={<KnowledgeTest />} />
//       <Route path="/get-ready/knowledge-test-selection" element={<KnowledgeTestSelect />} />
//       <Route path="/get-ready/knowledge-test-quiz/license-type/:LicenseTypeId" element={<GetReadyLicenseDetail />} />
//       <Route path="/get-ready/knowledge-test-quiz/attempt-quize" element={<AttemptQuize />}/>
//       <Route path="/Ebooks" element={<EBooks />} />
//       <Route path="/learner/comparecourses" element={<LearnerCompareCourses />} />
//       <Route path="/vli-blogs" element={<LearnerSideVliBlogs />} />
//       <Route path="/blog/:title" element={<ViewLearnerSideVliBlogs />} />
//       <Route path="/partnerregistration/:instituteId/:packageId" element={<PartnerOwnerRegisteration />} />
//       <Route path="/createpassword/:instituteId" element={<InstitutepasswordAndOtp />}/>
//       <Route path="/learner/createnewpassword/:UserId" element={<CreateLearnerNewPasswordPopup />} />
//       <Route path="/userlocation/:eventId" element={<MapView />}/>
//       <Route path="/track-student-livelocation/:UserId" element={<TrackStudentLiveLocation />}/>
//       <Route path="/find-course" element={<MobileViewFindCourse />}/>

//       <Route path="/g-license-preparation" element={<GetReadyWithKnowledgeTest />} />

//       <Route path="/get-ready/knowledge-history" element={<KnowledgeHistory />} />
//       <Route path="/get-ready/knowledge-history/:quizAttemptId/results" element={<QuizResultsDetails />} />


//     </Routes>
//   );
// };

const PublicRoutes = () => (
    <React.Fragment>
    <Route path="/contact-us" element={<ContactUsNew />} />
    <Route path="/about" element={<AboutNewSection />} />
    {/* <Route path="/course/:InstituteCourseId" element={<CourseOverview />} /> */}
    <Route path="/driving-courses/:city/:courseSlug" element={<CourseOverview />} />
    <Route path="/license-category/:type/:LicenseTypeId" element={<CourseCategory />} />
    <Route path="/vehicle-category/:type/:VehicleTypeId" element={<CourseCategory />} />
    <Route path="/sublicense-allcourses" element={<SublicenseAllCourses />} />
    <Route path="/get-ready" element={<Getready />} />
    <Route path="/get-ready/knowledge-test" element={<KnowledgeTestMain />} />
    <Route path="/get-ready/knowledge-test-quiz" element={<KnowledgeTest />} />
    <Route path="/get-ready/quiz" element={<KnowledgeTest />} />
    <Route path="/get-ready/knowledge-test-selection" element={<KnowledgeTestSelect />} />
    <Route
      path="/get-ready/quiz/:licenseSlug/:subLicenseSlug/:questionCount"
      element={<AttemptQuize />}
    />
    <Route
      path="/get-ready/quiz/:licenseSlug/:subLicenseSlug/select"
      element={<KnowledgeTestSelect />}
    />
    <Route
      path="/get-ready/quiz/:licenseSlug/:questionCount"
      element={<AttemptQuize />}
    />
    <Route
      path="/get-ready/quiz/:licenseSlug/select"
      element={<KnowledgeTestSelect />}
    />
    <Route path="/get-ready/quiz/:licenseSlug" element={<QuizLicenseTypePage />} />
    <Route path="/get-ready/knowledge-test-quiz/attempt-quize" element={<AttemptQuize />} />
    <Route path="/Ebooks" element={<EBooks />} />
    <Route path="/learner/comparecourses" element={<LearnerCompareCourses />} />
    <Route path="/vli-blogs" element={<LearnerSideVliBlogs />} />
    <Route path="/blog/:title" element={<ViewLearnerSideVliBlogs />} />
    <Route path="/partnerregistration/:instituteId/:packageId" element={<PartnerOwnerRegisteration />} />
    <Route path="/createpassword/:instituteId" element={<InstitutepasswordAndOtp />} />
    <Route path="/learner/createnewpassword/:UserId" element={<CreateLearnerNewPasswordPopup />} />
    <Route path="/userlocation/:eventId" element={<MapView />} />
    <Route path="/track-student-livelocation/:UserId" element={<TrackStudentLiveLocation />} />
    <Route path="/find-course" element={<MobileViewFindCourse />} />
    <Route path="/g-license-preparation" element={<GetReadyWithKnowledgeTest />} />
    <Route path="/get-ready/knowledge-history" element={<KnowledgeHistory />} />
    <Route path="/get-ready/knowledge-history/*" element={<QuizResultsDetails />} />

    <Route path="/bde-course" element={<BdeCourseRedirect />} />

    <Route path="/register/course" element={<RegisterNewCourse />} />

  </React.Fragment>
);

export default PublicRoutes;
